import { VStack } from '@chakra-ui/react';
import { Button } from 'Atoms';
import { TeamMembersFilterOption, useTeamMembers } from 'containers/TeamMembers';
import { Typography } from 'Tokens';
import { FilterIcon } from 'Tokens/Icons/Function';

export const TasksEmptyState = ({
  resetFilter,
  selectedUserId,
  customTitle,
  customBody,
  customButtonText,
  isSmall,
}: {
  resetFilter?: () => void;
  selectedUserId?: string;
  customTitle?: string;
  customBody?: string;
  customButtonText?: string;
  isSmall?: boolean;
}) => {
  const { members } = useTeamMembers(TeamMembersFilterOption.Active);
  return (
    <VStack
      h={isSmall ? 'fit-content' : '398px'}
      w="100%"
      justifyContent="center"
      bg="bg.muted"
      borderRadius="12px"
      gap="16px"
    >
      <VStack gap="4px" textAlign="center">
        {customTitle ? (
          <Typography variant="h4">{customTitle}</Typography>
        ) : (
          <Typography variant="h4">
            {selectedUserId
              ? `${members.find((member) => member.id === selectedUserId)?.name} does not have`
              : `You currently have no`}{' '}
            tasks assigned on this page.
          </Typography>
        )}
        <Typography variant="body" w={isSmall ? undefined : '350px'}>
          {customBody ?? "Change your filter to 'All tasks' to view the content on this page."}
        </Typography>
      </VStack>
      <Button leftIcon={<FilterIcon />} variant="ghost" onClick={resetFilter}>
        <Typography variant="bodyStrong">
          {customButtonText ?? 'Set filter to all tasks'}
        </Typography>
      </Button>
    </VStack>
  );
};
